<template>
  <Modal
    data-testid="schedule-modal"
    size="md"
    title=""
    :is-open="isOpen"
    @close="emitClose"
  >
    <HelperViewStatus
      title="Agendamento"
      :description="description"
      status="information"
    />
    <template #buttons>
      <ButtonPrimary
        label="Agendar transferência"
        :loading="isLoading"
        @click="emitScheduleWithdraw"
      />
    </template>
  </Modal>
</template>

<script setup lang="ts">
import {
  Modal,
  HelperViewStatus,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import * as trackEvents from '@/modules/transaction/views/NewTransfer/track-events';

interface Props {
  isOpen: boolean;
  description: string;
  isLoading?: boolean;
}

interface EmitEvents {
  (event: 'close'): void;
  (event: 'schedule-withdraw'): void;
}

withDefaults(defineProps<Props>(), {
  isLoading: false
});

const emit = defineEmits<EmitEvents>();

function emitClose() {
  trackEvents.trackScheduleDismissTransferClick();
  emit('close');
}
function emitScheduleWithdraw() {
  trackEvents.trackScheduleTransferPopupClick();
  emit('schedule-withdraw');
}
</script>

<style lang="less" scoped>
.helper-view {
  margin-bottom: @size-spacing-x700;
}
</style>
